import { Component, ElementRef, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import bwipjs from 'bwip-js';

@Component({
    selector: 'app-aztec-code',
    standalone: true,
    templateUrl: './aztec-code.component.html',
    styleUrls: ['./aztec-code.component.css'],
})
export class AztecCodeComponent implements AfterViewInit, OnChanges {
    @Input() base64Aztec = '';
    @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;

    private viewInitialized = false;

    ngAfterViewInit(): void {
        this.viewInitialized = true;
        this.render();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['base64Aztec'] && this.viewInitialized) {
            this.render();
        }
    }

    private render(): void {
        if (!this.base64Aztec || !this.canvasRef?.nativeElement) {
            return;
        }
        const canvas = this.canvasRef.nativeElement;

        try {
            const decoded =  this.base64ToHexString(this.base64Aztec);

            bwipjs.toCanvas(canvas, {
                bcid: 'azteccode',
                text: decoded,
                scale: 4,
                includetext: false,
                paddingwidth: 0,
                paddingheight: 0
            });
        } catch (error) {
            console.error('Failed to render Aztec code', error);
        }
  }

    private base64ToHexString(base64: string): string {
      const binary = atob(base64);
      let hexStr = '';
      for (let i = 0; i < binary.length; i++) {
        hexStr += binary.charCodeAt(i).toString(16).toUpperCase().padStart(2, '0');
      }
      return hexStr;
    }
}
